"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleTypePriceFee = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
let VehicleTypePriceFee = class VehicleTypePriceFee {
    vehicleType;
    /**
     * Same as {@link Order#price} but per vehicle
     * */
    price = 0;
    /**
     * Same as {@link Order#fee} but per vehicle
     * */
    fee = 0;
    isManuallyModified = false;
    constructor(init) {
        Object.assign(this, init);
    }
};
exports.VehicleTypePriceFee = VehicleTypePriceFee;
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypePriceFee.prototype, "vehicleType", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Float),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypePriceFee.prototype, "price", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Float),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], VehicleTypePriceFee.prototype, "fee", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], VehicleTypePriceFee.prototype, "isManuallyModified", void 0);
exports.VehicleTypePriceFee = VehicleTypePriceFee = __decorate([
    (0, type_graphql_1.ObjectType)("VehicleTypePriceFee"),
    (0, type_graphql_1.InputType)("VehicleTypePriceFeeInput"),
    (0, class_transformer_1.Exclude)(),
    __metadata("design:paramtypes", [Object])
], VehicleTypePriceFee);
//# sourceMappingURL=VehicleTypePriceFee.js.map